export default __webpack_public_path__ + "static/media/pic13.33476efa.jpg";